import React, { useMemo } from 'react'
import { DocusignSigningField } from 'src/interfaces/docusign'
import { DocusignFieldsFormInput } from './DocusignFieldsFormInput'
import {
  DocusignFieldTabLabel,
  docusignSectionsMap,
  docusignSectionsTitleMap,
  DocusignSectionTitle,
  TaxClassificationType,
} from 'src/constants/docusign'
import { useFormikContext } from 'formik'
import { DocusignFieldsFormValues } from './DocusignFieldsForm.interface'
import tw from 'twin.macro'
import { Typography } from '@mui/material'

interface Props {
  fields: Array<DocusignSigningField>
}

export const DocusignFieldsFormInputList = ({ fields }: Props) => {
  const { values } = useFormikContext<DocusignFieldsFormValues>()

  const orderedFields = useMemo<
    { sectionKey: DocusignSectionTitle; fields: DocusignSigningField[] }[]
  >(() => {
    const orderedFieldsRes: {
      sectionKey: DocusignSectionTitle
      fields: DocusignSigningField[]
    }[] = []

    Object.entries(docusignSectionsMap).forEach(([key, fieldItems]) => {
      const res: { sectionKey: DocusignSectionTitle; fields: DocusignSigningField[] } = {
        sectionKey: key as DocusignSectionTitle,
        fields: [],
      }

      const taxClassificationTypeValue = values[DocusignFieldTabLabel.taxClassificationType]

      fieldItems.forEach((fieldItem) => {
        const fieldToAdd = fields.find((field) => field.tabLabel === fieldItem)

        if (
          fieldItem === DocusignFieldTabLabel.llcType &&
          taxClassificationTypeValue !== TaxClassificationType.Llc
        ) {
          return
        }

        if (
          fieldItem === DocusignFieldTabLabel.otherTaxClassification &&
          taxClassificationTypeValue !== TaxClassificationType.Other
        ) {
          return
        }

        if (fieldToAdd) {
          res.fields.push(fieldToAdd)
        }
      })

      if (res.fields.length) {
        orderedFieldsRes.push(res)
      }
    })

    return orderedFieldsRes
  }, [fields, values])

  return (
    <div>
      {orderedFields.map((item) => {
        return (
          <div css={tw`mb-4`} key={item.sectionKey}>
            <Typography
              variant="h6"
              css={tw`mt-4 pb-2 border-0 border-b border-solid border-[#EDEDED]`}
            >
              {docusignSectionsTitleMap[item.sectionKey]}
            </Typography>
            <div css={tw`pt-2`}>
              {item.fields.map((field) => (
                <DocusignFieldsFormInput key={field.tabLabel} field={field} />
              ))}
            </div>
          </div>
        )
      })}
    </div>
  )
}
